module.exports = __webpack_public_path__ + "img/61.e3c0ed37.jpg";